import { RefreshCw } from 'lucide-react'
import { useAppUpdate } from '@/hooks/useAppUpdate'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'

/**
 * Persistent in-app strip when a new web deploy is ready (PWA / TWA).
 * Complements the Sonner toast so mobile users always see Reload.
 */
export function AppUpdateBanner({ className }: { className?: string }) {
  const { updateAvailable, reload } = useAppUpdate()

  if (!updateAvailable) return null

  return (
    <div
      role="status"
      className={cn(
        'flex shrink-0 items-center gap-2 border-b border-primary/25 bg-primary/10 px-3 py-2 text-sm text-foreground',
        className,
      )}
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      <p className="min-w-0 flex-1 truncate font-medium">Update available</p>
      <Button type="button" size="sm" className="h-8 shrink-0 px-3" onClick={reload}>
        Reload
      </Button>
    </div>
  )
}
